import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import _ from "lodash";
import { useLocation, useNavigate } from "react-router-dom";
import { FormProvider, useForm } from "react-hook-form";
import moment from "moment-timezone";
import { HouseRentalForm } from "@/types/house-rental.type";
import { useAddHouseRentalMutation } from "@/services/house-rental.service";
import Information from "./_information";

export default function AddHouseRental() {
    const { t } = useTranslation()
    const location = useLocation()
    const navigate = useNavigate()
    const [addRental, {isSuccess}] = useAddHouseRentalMutation()
    const methods = useForm<HouseRentalForm>()
    const {handleSubmit} = methods

    const onSubmit = handleSubmit((data) => {
        let now = moment()
        addRental({
            ...data,
            rent: Number(data.rent),
            deposit_amount: Number(data.deposit_amount),
            rent_free: _.isEmpty(data.rent_free) ? -1 : Number(data.rent_free),
            warranty: _.isEmpty(data.warranty) ? -1 : Number(data.warranty),
            ta_start: moment(`${data.ta_start} ${now.hours()}:${now.minutes()}:${now.seconds()}.${now.milliseconds()}`, 'YYYY-MM-DD HH:mm:ss.SSS').toISOString(),
            ta_duration: Number(data.ta_duration),
            ta_end: moment(`${data.ta_end} ${now.hours()}:${now.minutes()}:${now.seconds()}.${now.milliseconds()}`, 'YYYY-MM-DD HH:mm:ss.SSS').toISOString(),
            take_over: moment(`${data.take_over} ${now.hours()}:${now.minutes()}:${now.seconds()}.${now.milliseconds()}`, 'YYYY-MM-DD HH:mm:ss.SSS').toISOString(),
            option_to_renew: data.option_to_renew,
        })
    })

    useEffect(() => {
        if(isSuccess) {
            navigate(location, {state: {reload: true}})
        }
    }, [isSuccess])

    return (
        <div x-show="modalOpen" x-transition="" className="fixed top-0 left-0 z-99999 flex h-full min-h-screen w-full items-center justify-center bg-black/90 px-4 py-5">
            <div className="w-full max-w-screen-lg rounded-lg bg-white py-5 px-8 dark:bg-boxdark">
                <h3 className="text-xl dark:text-white text-center font-medium my-5">
                    {t("house_rental.add_house_rental")}
                </h3>
                <form className="mx-5" onSubmit={onSubmit}>
                    <FormProvider {...methods}>
                        <Information />
                    </FormProvider>
                    <div className="flex justify-end">
                        <div className="px-3">
                            <button type="button" onClick={() => navigate(location)} className="block w-full rounded border border-stroke bg-gray-400 p-1.5 px-3 text-center font-medium text-black transition hover:bg-opacity-90">
                                {t("modal.cancel")}
                            </button>
                        </div>
                        <div className="px-3">
                            <button type="submit" className="flex w-full justify-center rounded bg-primary p-1.5 px-3 text-white hover:bg-opacity-90">
                                {t("modal.submit")}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}
